import React from 'react';
import { BaseButton } from '@/app/components/buttons/BaseButton';
import { ProvideUploadFile } from '@/context/UploadFileProvider';
import { useModalState } from '@/hooks/useModalState';
import type {
  ClientDocumentResponse,
  ClientDocumentWithPassportData,
  PassportDataWithName,
} from '@/types/clientsApiTypes';
import { UploadDocumentModal } from '../../../components/UploadDocumentModal';
import { DocumentTable } from './components/DocumentTable';
import PlusIcon from '/public/icons/plus.svg';

interface DocumentsSectionProps {
  documents: ClientDocumentWithPassportData[];
  tableRowClassName?: string;
  passengerId?: number | string;
  fieldPrefix: string;
  passengerFullName: string;
  isPublicPage?: boolean;
  onSuccess?: (data: ClientDocumentResponse) => void;
  onUpdateDocuments?: (documents: PassportDataWithName, documentId: number | null) => void;
  onDeleteDocuments?: (documentId: number) => void;
}

export const DocumentsSection = ({
  documents,
  fieldPrefix,
  passengerId,
  tableRowClassName,
  passengerFullName,
  isPublicPage,
  onSuccess,
  onUpdateDocuments,
  onDeleteDocuments,
}: DocumentsSectionProps) => {
  const { isOpen, open, close } = useModalState();

  return (
    <ProvideUploadFile>
      <div className="flex justify-between w-full items-center">
        <p className="text-black font-semibold font-inter text-lg leading-normal">
          Passport and Travel Document Uploads
        </p>
        <BaseButton startIcon={<PlusIcon />} onClick={open} intent="ghost" size="ghost_small" type="button">
          Add Document
        </BaseButton>
      </div>
      <div className="flex flex-col gap-4 w-full overflow-x-auto">
        {isOpen ? (
          <UploadDocumentModal
            isPublicPage={isPublicPage}
            documentsCount={documents.length}
            onSuccess={onSuccess}
            isOpen={isOpen}
            onClose={close}
            passengerId={passengerId}
          />
        ) : null}
        {documents.length > 0 ? (
          <DocumentTable
            passengerFullName={passengerFullName}
            tableRowClassName={tableRowClassName}
            onDeleteDocuments={onDeleteDocuments}
            onUpdateDocuments={onUpdateDocuments}
            documents={documents}
            fieldPrefix={fieldPrefix}
          />
        ) : null}
      </div>
    </ProvideUploadFile>
  );
};